module.exports = __webpack_public_path__ + "img/pc-textlink-03.5ad1867a.svg";